import { Box, Button, Tooltip, Typography, useTheme } from '@mui/material';
import { tokens } from '../theme';

function BrandProductBox({ brandProduct, onEditClick, onDeleteClick }) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    return (
        <Box m="10px" mb="20px" p="20px"
            width={"30%"}
            display="inline-block"
            sx={{
                background: (theme.palette.mode === "dark" ? colors.primary[500] : "white"), border: "1px solid " + colors.grey[500],
                borderRadius: "20px"
            }}
        >
            <Box display="flex" justifyContent="space-between">
                <Box display="flex" alignItems="center" >
                    <Box>
                        <img
                            alt="product"
                            src={brandProduct.image_link_1}
                            width="40px"
                            height="40px"
                            style={{ cursor: "pointer", borderRadius: "20%" }} />
                    </Box>
                    <Box ml="10px">
                        <Box display="flex" gap="5px">
                            <Typography variant='h4'>{brandProduct.name}</Typography>
                        </Box>
                        <Typography variant='h6' >{brandProduct.brand_name}</Typography>
                    </Box>
                </Box>
            </Box>
            <hr style={{ border: "1px solid " + (theme.palette.mode === "dark" ? "white" : "black") }} />

            <Box>
                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Açıklama:</b> <br />{brandProduct.description || "-"}</Typography>

                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Fiyat:</b> <br />{brandProduct.price || "-"}</Typography>
                <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>İndirimli Fiyat:</b> <br />{brandProduct.discounted_price || "-"}</Typography>

                {brandProduct.link.length >= 30 &&
                    <Tooltip title={brandProduct.link}>
                        <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Websitesi:</b> <br /><a href={brandProduct.link} target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: colors.primary[100] }}>{brandProduct.link.slice(0, 30) + "..."}</a></Typography>
                    </Tooltip>
                }

                {brandProduct.link.length < 30 &&
                    <Typography variant='h6' maxWidth="250px" mt="10px" ml="20px"><b>Websitesi:</b> <br /><a href={brandProduct.link} target='_blank' rel="noreferrer" style={{ textDecoration: "none", color: colors.primary[100] }}>{brandProduct.link}</a></Typography>
                }

                <hr style={{ border: "1px solid " + (theme.palette.mode === "dark" ? "white" : "black"), marginTop: "20px" }} />
            </Box>

            <Box display={"flex"} justifyContent={"space-evenly"} mt="10px">
                <Button variant='contained' sx={{ background: colors.blueAccent[500] }} onClick={() => onEditClick(brandProduct)}>Düzenle</Button>
                <Button variant='contained' color="error" onClick={() => onDeleteClick(brandProduct)}>Sil</Button>
            </Box>
        </Box >
    )
}

export default BrandProductBox